import { render } from "./AssociationContractViewDrawer.vue?vue&type=template&id=896a317e&ts=true"
import script from "./AssociationContractViewDrawer.vue?vue&type=script&lang=ts"
export * from "./AssociationContractViewDrawer.vue?vue&type=script&lang=ts"

import "./AssociationContractViewDrawer.vue?vue&type=style&index=0&id=896a317e&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__